import React from "react";

const About = () => (
	<section id="about" className="py-16 px-6 max-w-4xl mx-auto text-center">
		<h3 className="text-3xl font-bold text-[#031B4E] mb-4">About Us</h3>
		<p className="text-gray-700">
			LightYear Telecom Enterprise Limited is at the forefront of
			telecommunications, offering end-to-end solutions that ensure reliable
			connectivity, secure networks, and advanced IT services for businesses and
			individuals.
		</p>
	</section>
);

export default About;
